

import  React from 'react';
import Ingreso from './components/ingreso.jsx';
import Home from './components/Home.jsx';
import {Routes,Route } from 'react-router-dom';
import Tutoriales from './components/tutorials/Tutoriales.jsx';
import MenuRutas from './components/rutas/menuRutas.jsx'
import PasosRuta from './components/rutas/pasosRuta.jsx'
import Velocidad from './components/velocidad.jsx';
import Referidos from './components/referidos.jsx';
import ConsultaValidez from './components/consultaValidez.jsx'
import ContainerCompartidoReproductor from './components/ReproductorCompartido.jsx';
import AdminTutorials from './components/editTutorials/adminTutorials.jsx';
import Digemid from "./components/digemid.jsx"

import Compartido from './components/compartido.jsx';
import Cards from './components/tutorials/cards.jsx';

document.body.style.margin="0px";
document.body.style.overflow="hidden";

function App() {
  
  return (
  
    <Routes>

          <Route path="/" element={<Ingreso />} /> 
                    
          <Route path="/Home" element={<Home/>} >
              <Route path="Tutoriales" element={<Tutoriales/>} >
                  <Route path="rutas de implementacion" element={<MenuRutas/>} /> 
                  <Route path="pasos/:id" element={<PasosRuta/>} />                  
                  <Route path=":grupo" element={<Cards/>}/>           
              </Route>              
              <Route path="Referidos" element={<Referidos/>} />
              <Route path="Velocidad" element={<Velocidad/>} />
              <Route path="Upload" element={<AdminTutorials/>} />
              <Route path="ConsultaValidez" element={<ConsultaValidez/>} />
              <Route path="Digemid" element={<Digemid/>} />
          </Route>          

          <Route path="/Compartido" element={<Compartido/>}>
              <Route path="MenuRutas" element={<MenuRutas/>}/>
              <Route path="Referidos" element={<Referidos/>} / >
              <Route path="Reproductor/:id" element={<ContainerCompartidoReproductor/>} / >
              <Route path="Velocidad" element={<Velocidad/>} / >
              <Route path="ConsultaValidez" element={<ConsultaValidez/>} / >
          </Route>
     

    </Routes>

  

   )
}

export default App;
